import { render } from "./modalsContainer.vue?vue&type=template&id=767b4dca&scoped=true&ts=true"
import script from "./modalsContainer.vue?vue&type=script&lang=ts"
export * from "./modalsContainer.vue?vue&type=script&lang=ts"

import "./modalsContainer.vue?vue&type=style&index=0&id=767b4dca&scoped=true&lang=css"
import "./modalsContainer.vue?vue&type=style&index=1&id=767b4dca&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767b4dca"]])

export default __exports__